"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18next_1 = __importDefault(require("i18next"));
const functions_1 = require("@/common/functions");
function default_1(type) {
    const isForm = type === 'form';
    alert(`${i18next_1.default.t(isForm ? '존재하지 않는 폼이에요' : '존재하지 않는 링크예요')}!`);
    (0, functions_1.goToMain)();
}
exports.default = default_1;
